import user from '../../Basics/User'
const god = {
  templateName: 'cardTemplateVip17',
  imgSrc: 'card/template/vip00/cardTemplateVip17.png',
  desc: '林间小路',
  category: 'card',
  vipGrade: 0,
  attr: {
    textColor: {
      type: 'color',
      id: '',
      label: '文本颜色',
      value: '#fff'
    },
    bgImage: {
      type: 'image',
      id: '',
      label: '背景图片',
      value: 'card/material/scene07.jpg'
    },
    modelSrc: {
      type: 'model',
      id: '',
      label: '上传模型',
      value: 'model/Lang.gltf'
    }
  }
}
god.attr = Object.assign(god.attr, user)
export default god
